import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { NotificationService } from '../../services/notifications.service';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NAME_PROJECT } from '../../enum/constants';

@Component({
  selector: 'app-tariff',
  templateUrl: './tariff-update.component.html',
  styleUrls: ['./tariff-update.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TariffUpdateComponent implements OnInit, OnDestroy {
  public isLoader: boolean = false;

  constructor(
    private clipboard: Clipboard,
    private notificationService: NotificationService,
    private dialogRef: MatDialogRef<TariffUpdateComponent>,
    private router: Router,
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  click() {
    this.router.navigate(['/crm/payment'], {
      queryParams: { tab: 'ADDITIONAL_CHANNELS' },
      queryParamsHandling: 'merge',
    });
    this.dialogRef.close();
  }

  protected readonly NAME_PROJECT = NAME_PROJECT;
}
